(() => {
  if (window.edenCartInitialized) return;
  window.edenCartInitialized = true;
  function init(scope = document) {
    const root = scope.matches?.('[data-eden-cart-section]') ? scope : scope.querySelector('[data-eden-cart-section]');
    const form = root?.querySelector('[data-eden-cart]');
    if (!form || form.dataset.ready) return;
    form.dataset.ready = 'true';
    const feedback = root.querySelector('[data-eden-cart-feedback]');
    const inputs = [...form.querySelectorAll('[data-eden-cart-quantity]')];
    let busy = false;
    let timer;
    const checkout = form.querySelector('[name="checkout"]');
    const orderingDisabled = checkout?.disabled;
    const announce = (message, error = false) => {
      feedback.textContent = message;
      feedback.classList.toggle('is-error', error);
    };
    async function update(focusKey) {
      clearTimeout(timer);
      if (busy) return;
      const updates = {};
      for (const input of inputs) {
        const quantity = Number(input.value);
        const minimum = Number(input.dataset.minimum) || 1;
        const increment = Number(input.step) || 1;
        const maximum = input.max === '' ? Infinity : Number(input.max);
        const valid = input.value.trim() !== '' && Number.isSafeInteger(quantity) && quantity >= 0 && quantity <= maximum && (quantity === 0 || (quantity >= minimum && quantity % increment === 0));
        input.setCustomValidity(valid ? '' : form.dataset.invalid);
        if (!valid) {
          announce(form.dataset.invalid, true);
          input.reportValidity();
          if (checkout) checkout.disabled = orderingDisabled;
          return;
        }
        updates[input.dataset.key] = quantity;
      }
      busy = true;
      form.setAttribute('aria-busy', 'true');
      const controls = [...form.querySelectorAll('button, input, textarea')];
      const states = controls.map(control => control.disabled);
      controls.forEach(control => { control.disabled = true; });
      form.querySelectorAll('[data-eden-cart-remove]').forEach(link => link.setAttribute('aria-disabled', 'true'));
      announce(form.dataset.updating);
      const note = form.querySelector('[name="note"]')?.value || '';
      try {
        const response = await fetch(form.dataset.updateUrl, {
          method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({updates, note, sections: [root.dataset.sectionId], sections_url: location.pathname})
        });
        const cart = await response.json();
        if (!response.ok) throw new Error(typeof cart.description === 'string' ? cart.description : form.dataset.error);
        const html = cart.sections?.[root.dataset.sectionId];
        if (typeof html !== 'string') { location.reload(); return; }
        const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-eden-cart-section]');
        if (!next) { location.reload(); return; }
        root.replaceWith(next);
        document.querySelectorAll('.cart-count').forEach(count => { count.textContent = cart.item_count; });
        init(next);
        const status = next.querySelector('[data-eden-cart-feedback]');
        const shippingMessage = next.querySelector('[data-eden-shipping-message]')?.textContent || '';
        if (status) status.textContent = `${form.dataset.updated} ${shippingMessage}`.trim();
        const focusedInput = [...next.querySelectorAll('[data-eden-cart-quantity]')].find(input => input.dataset.key === focusKey);
        focusedInput?.focus({preventScroll: true});
      } catch (error) {
        announce(error.message || form.dataset.error, true);
        inputs.forEach(input => { input.value = input.dataset.quantity; input.setCustomValidity(''); });
        controls.forEach((control, index) => { control.disabled = states[index]; });
        if (checkout) checkout.disabled = orderingDisabled;
        form.querySelectorAll('[data-eden-cart-remove]').forEach(link => link.removeAttribute('aria-disabled'));
        form.removeAttribute('aria-busy');
        busy = false;
      }
    }
    inputs.forEach(input => {
      input.addEventListener('input', () => {
        input.setCustomValidity('');
        clearTimeout(timer);
        if (checkout) checkout.disabled = true;
        timer = setTimeout(() => update(input.dataset.key), 500);
      });
      input.addEventListener('change', () => update(input.dataset.key));
    });
    form.querySelectorAll('[data-eden-cart-remove]').forEach(link => link.addEventListener('click', event => {
      event.preventDefault();
      if (busy) return;
      const input = link.closest('[data-eden-line]').querySelector('[data-eden-cart-quantity]');
      input.value = '0';
      update();
    }));
    form.addEventListener('submit', event => {
      if (event.submitter?.name === 'checkout') return;
      event.preventDefault();
      update();
    });
  }
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', event => init(event.target));
  window.addEventListener('pageshow', event => { if (event.persisted) location.reload(); });
  if (document.readyState !== 'loading') init();
})();
